import React from 'react';
import PropTypes from 'prop-types';
import { withScreenSize } from './../hoc';

import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import { history } from '../../configuration/store';

import './tabs.css';

class Tabs extends React.Component {
    constructor(props) {
        super(props);
        const { isMobile } = props;
        const defaultTab = this.makeInt(new URLSearchParams(history.location.search).get('tab') || this.props.defaultTab);

        this.state = {
            menuVisible: true,
            activeTab: isMobile ? undefined : defaultTab
        };

        this.renderTitle = this.renderTitle.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.backToMenu = this.backToMenu.bind(this);
    }

    onTabClick(index) {
        const { isMobile } = this.props;
        this.setState({ ...this.state, menuVisible: !isMobile, activeTab: index });

        const search = new URLSearchParams(history.location.search);
        search.set('tab', index);

        history.replace({
            pathname: history.location.path,
            search: search.toString()
        });
    }

    backToMenu() {
        const { isMobile } = this.props;
        this.setState({ ...this.state, menuVisible: true, activeTab: isMobile ? undefined : this.state.activeTab });
    }

    renderTitle() {
        const { title, isPageTitle, items, isMobile } = this.props;
        const { menuVisible, activeTab } = this.state;

        return (
            <React.Fragment>
                {isMobile && menuVisible !== true ? (
                    <div className="mobile-tabs-title">
                        <div onClick={this.backToMenu}>
                            <div className="tabs-title text-primary">
                                <i className="material-icons">arrow_left</i> {title || <FormattedMessage {...messages.back} />}
                            </div>
                        </div>
                        <div className="tabs-title">
                            <h4>{items[activeTab].title}</h4>
                        </div>
                    </div>
                ) : (
                    title && (
                        <div className={isMobile ? 'mobile-tabs-title' : ''}>
                            <div className="tabs-title">{isPageTitle ? <h4>{title}</h4> : title}</div>
                        </div>
                    )
                )}
            </React.Fragment>
        );
    }

    makeInt(numOrString) {
        if (numOrString && typeof numOrString === 'string') return parseInt(numOrString, 10);
        return numOrString;
    }

    render() {
        const { items, underlined, pageWide, isMobile } = this.props;
        const defaultTab = this.makeInt(this.props.defaultTab);

        const { menuVisible, activeTab } = this.state;
        return (
            <div className="row">
                <div className="col-xs-12 tabs-component">
                    {this.renderTitle()}
                    <div className={`tabs-container ${pageWide ? 'page-wide' : ''}`}>
                        <div className={`tabs-navigator no-select ${underlined ? 'underlined' : ''}`}>
                            {menuVisible ? (
                                <React.Fragment>
                                    {items.map((item, index) => (
                                        <div
                                            key={index}
                                            id={index}
                                            className={`tab-button ${index === activeTab ? 'active' : 'inactive'} ${
                                                isMobile && index === defaultTab ? 'mobile-active' : ''
                                            }`}
                                            onClick={() => this.onTabClick(index)}
                                        >
                                            <div className={`ellipsis ${!isMobile && item.style === 'light' ? 'light-button' : ''}`}>
                                                <span>
                                                    {item.title} {isMobile && <i className="material-icons pull-right">arrow_right</i>}
                                                </span>{' '}
                                            </div>
                                        </div>
                                    ))}
                                    {!isMobile && (
                                        <div className="tab-button last">
                                            <div className="ellipsis">
                                                <span>.</span>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : null}
                        </div>
                        <div className={`tabs-content ${activeTab !== undefined ? 'active' : 'inactive'} `}>
                            {activeTab !== undefined ? items[activeTab].content : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Tabs.defaultProps = {
    title: undefined,
    isPageTitle: false,
    items: [],
    pageWide: false,
    undelined: true,
    defaultTab: 0
};

Tabs.propTypes = {
    title: PropTypes.any,
    isPageTitle: PropTypes.bool,
    items: PropTypes.array.isRequired,
    pageWide: PropTypes.bool,
    underlined: PropTypes.bool,
    defaultTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default withScreenSize(Tabs);



// WEBPACK FOOTER //
// ./src/components/tabs/index.jsx